import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

export default function MainLayout({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden", // OK here
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Right Section */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0, // 🔥 CRITICAL
        }}
      >
        <TopBar />

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            px: { md: 5, xs: 2 },
            py: 3,
            minWidth: 0,        // 🔥 CRITICAL
            overflowY: "auto",  // vertical scroll only
            overflowX: "hidden",// allow child to scroll
            background:
              "linear-gradient(180deg, var(--bg-gradient-start), var(--bg-gradient-end))",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
